export default function CTA() {
  return (
    <section className="relative overflow-hidden bg-primary-500 px-4 py-14 md:px-6 md:py-20">
      <div className="absolute -right-8 -top-8 h-40 w-40 rounded-full bg-primary-400/40 blur-2xl"></div>
      <div className="absolute -bottom-10 -left-8 h-44 w-44 rounded-full bg-accent-500/30 blur-2xl"></div>
      <div className="relative mx-auto flex max-w-4xl flex-col items-center text-center">
        <span className="mb-3 inline-flex items-center gap-1.5 rounded-full bg-background-50/15 px-4 py-1.5 text-sm font-medium text-background-50 backdrop-blur-sm">
          <i className="ri-magic-fill text-secondary-300"></i>
          每天都有新惊喜
        </span>
        <h2 className="font-heading max-w-2xl text-2xl text-background-50 md:text-4xl">
          想要的漫画，这里都能找到
        </h2>
        <p className="mt-3 max-w-xl text-sm leading-7 text-background-100 md:text-base">
          今日更新与热门榜单每日刷新，编辑推荐、新作首发、高分漫画与人气连载持续补充，
          跟着第一页一起追更，不错过任何一部好作品。
        </p>
        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <a
            href="#today"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-background-50 px-7 py-3 text-sm font-bold text-foreground-950 whitespace-nowrap transition-colors hover:bg-background-100"
          >
            <i className="ri-refresh-line"></i>
            今日更新抢先看
          </a>
          <a
            href="#faq"
            className="inline-flex items-center justify-center gap-2 rounded-full border border-background-50/40 px-7 py-3 text-sm font-bold text-background-50 whitespace-nowrap transition-colors hover:bg-background-50/10"
          >
            <i className="ri-question-line"></i>
            更多问题解答
          </a>
        </div>
      </div>
    </section>
  );
}